import { authentication } from '@ecosystem/newron-client-lib';
import { DataResults, HTTPMethod, Params } from '../types';
import axios from 'axios';
import { clientToImpersonate } from './impersonate';
import { SimpleMessageError } from '../design/error/simpleMessageError';
import { DEFAULT_SECTION_ERROR_MESSAGE } from '../common/constants/error';
import { ProviderCollectionProps } from '../data/types';
import { getFeatureFlagHeaders } from './featureFlags';

axios.defaults.headers.common['Accept'] = 'application/json';

async function getData(
  url: string,
  params: Params,
  requestId: string,
  requestMethod: HTTPMethod = HTTPMethod.GET,
  collection?: ProviderCollectionProps
): Promise<DataResults | null> {
  const token = await authentication.getAccessToken();

  try {
    const response = await request(token, requestId, requestMethod, url, params, collection);

    if (!response.data) {
      throw new SimpleMessageError(DEFAULT_SECTION_ERROR_MESSAGE);
    }
    return response.data;
  } catch (err) {
    throw new SimpleMessageError(err?.response?.data || DEFAULT_SECTION_ERROR_MESSAGE);
  }
}

const request = async (
  token: string,
  requestId: string,
  requestMethod: HTTPMethod,
  url: string,
  params: Params,
  collection?: ProviderCollectionProps
) => {
  const headers = {
    Authorization: `Bearer ${token}`,
    ...(await clientToImpersonate(collection)),
    ...(await getFeatureFlagHeaders()),
  };

  const paramsWithRequestId: Params = { ...params, requestId: [requestId] };

  if (requestMethod === HTTPMethod.POST) {
    return await axios.post<DataResults>(url, paramsWithRequestId, {
      headers,
    });
  } else {
    const search = prepareURLParams(paramsWithRequestId);
    return await axios.get<DataResults>(url, {
      headers,
      params: search,
    });
  }
};

const prepareURLParams = (params: Params) => {
  const search = new URLSearchParams();
  Object.keys(params).forEach(name => {
    const values = params[name];
    values.forEach(value => {
      search.append(name, value);
    });
  });
  return search;
};

export const dataClient = {
  getData,
};
